import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useState } from 'react';
import dayjs from 'dayjs';
import { dateToString } from "../../utils";
import { addMonth, subtractMonth } from "../utils";
export function useHighlightManager(_ref) {
  var year = _ref.year,
      month = _ref.month,
      goToMonth = _ref.goToMonth,
      isDateDisabled = _ref.isDateDisabled,
      onDateSelected = _ref.onDateSelected;

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      highlightedDate = _useState2[0],
      setHighlight = _useState2[1];

  var moveHighlight = useCallback(function (daysOffset) {
    if (!highlightedDate) {
      return;
    }

    var newDate = dayjs.utc(highlightedDate).add(daysOffset, 'day');
    goToMonth(newDate.month(), newDate.year());
    setHighlight(newDate.toDate());
  }, [highlightedDate, goToMonth]);
  var moveHighlightToMonthStart = useCallback(function () {
    var firstDay = dayjs.utc().year(year).month(month).startOf('month').toDate();
    setHighlight(firstDay);
  }, [year, month, setHighlight]);
  var moveHighlightToMonthEnd = useCallback(function () {
    var lastDay = dayjs.utc().year(year).month(month).endOf('month').toDate();
    setHighlight(lastDay);
  }, [year, month, setHighlight]);
  var moveHighlightByMonthOffset = useCallback(function (monthOffset) {
    if (!highlightedDate || monthOffset === 0) {
      return;
    }

    var newDate = dayjs.utc(highlightedDate).add(monthOffset, 'month');

    var _ref2 = monthOffset >= 0 ? addMonth(month, year) : subtractMonth(month, year),
        _ref3 = _slicedToArray(_ref2, 2),
        nextMonth = _ref3[0],
        nextYear = _ref3[1];

    goToMonth(nextMonth, nextYear);
    setHighlight(newDate.toDate());
  }, [month, year, highlightedDate, goToMonth, setHighlight]);
  var goToPreviousMonth = useCallback(function () {
    var _subtractMonth = subtractMonth(month, year),
        _subtractMonth2 = _slicedToArray(_subtractMonth, 2),
        newMonth = _subtractMonth2[0],
        newYear = _subtractMonth2[1];

    goToMonth(newMonth, newYear);
  }, [month, year, goToMonth]);
  var goToNextMonth = useCallback(function () {
    var _addMonth = addMonth(month, year),
        _addMonth2 = _slicedToArray(_addMonth, 2),
        newMonth = _addMonth2[0],
        newYear = _addMonth2[1];

    goToMonth(newMonth, newYear);
  }, [month, year, goToMonth]);
  var handleDateSelection = useCallback(function (date) {
    if (!!isDateDisabled && isDateDisabled(dateToString(date))) {
      return;
    }

    goToMonth(date.getUTCMonth(), date.getUTCFullYear());
    onDateSelected(date);
  }, [isDateDisabled, goToMonth, onDateSelected]);
  var handleDateHighlighted = useCallback(function (date) {
    return setHighlight(date);
  }, [setHighlight]);
  return {
    highlightedDate: highlightedDate,
    moveHighlight: moveHighlight,
    moveHighlightToMonthEnd: moveHighlightToMonthEnd,
    moveHighlightByMonthOffset: moveHighlightByMonthOffset,
    moveHighlightToMonthStart: moveHighlightToMonthStart,
    goToPreviousMonth: goToPreviousMonth,
    goToNextMonth: goToNextMonth,
    handleDateSelection: handleDateSelection,
    handleDateHighlighted: handleDateHighlighted
  };
}